const SELECT_REQUEST = 'rate-types/select/request'
const SELECT_SUCCESS = 'rate-types/select/success'
const SELECT_FAILURE = 'rate-types/select/failure'

export { SELECT_REQUEST, SELECT_SUCCESS, SELECT_FAILURE }
